import { useState, useEffect } from 'react';
import { TranslatedLanguage } from '@/interface/common';

export const useLanguage = (): TranslatedLanguage => {
  const [currentLanguage, setCurrentLanguage] = useState<TranslatedLanguage>(
    TranslatedLanguage.en,
  );

  useEffect(() => {
    // Get initial language
    const getInitialLanguage = (): TranslatedLanguage => {
      const storedLanguage = localStorage.getItem('i18nextLng');
      if (storedLanguage) {
        const lang = storedLanguage.slice(0, 2);
        if (lang === 'en') return TranslatedLanguage.en;
        if (lang === 'fr') return TranslatedLanguage.fr;
        if (lang === 'es') return TranslatedLanguage.es;
      }

      const browserLanguage = (navigator.language || 'en').slice(0, 2);
      if (browserLanguage === 'en') return TranslatedLanguage.en;
      if (browserLanguage === 'fr') return TranslatedLanguage.fr;
      if (browserLanguage === 'es') return TranslatedLanguage.es;

      return TranslatedLanguage.en;
    };

    setCurrentLanguage(getInitialLanguage());

    // Listen for language changes
    const handleLanguageChange = () => {
      setCurrentLanguage(getInitialLanguage());
    };

    window.addEventListener('storage', handleLanguageChange);

    window.addEventListener('languageChanged', handleLanguageChange);

    return () => {
      window.removeEventListener('storage', handleLanguageChange);
      window.removeEventListener('languageChanged', handleLanguageChange);
    };
  }, []);

  return currentLanguage;
};
